const staticProductList = [
    'Optimize',
    'Automate',
    'Manage',
    'Monitor',
    'Plan',
    'Design',
    'UserAdmin'
  ];
  
  export default staticProductList;